import { FC, ReactNode } from 'react';
import stylex from '@stylexjs/stylex';
import type { OptionInfo } from '@entities/leadCollector';
import { styles } from '../MainGuestTab/styles';

export interface OptionItemRowProps {
  option: OptionInfo;
  children: ReactNode;
}

export const OptionItemRow: FC<OptionItemRowProps> = ({ option, children }) => (
  <label {...stylex.props(styles.deliveryMethodOption)}>
    {children}
    <span
      {...stylex.props(styles.radioLabel)}
      dangerouslySetInnerHTML={option.text ? { __html: option.text } : undefined}
    />
  </label>
);
